module.exports = __webpack_public_path__ + "static/media/info-title.740a77f3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/resources/info/info-title.gif
// module id = 1743
// module chunks = 0